var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUserGray16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "839DED4B-9C21-4E80-AD9C-E6A434A71444_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.29813058
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-1274.000000, -32.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1218.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,18 L21,18 C18.238,18 16,20.238 16,23 C16,23.5530005 16.447,24 17,24 L27,24 C27.553,24 28,23.5530005 28,23 C28,20.238 25.762,18 23,18 Z M22,16 C23.657,16 25,14.657 25,13 L25,11 C25,9.343 23.657,8 22,8 C20.343,8 19,9.343 19,11 L19,13 C19,14.657 20.343,16 22,16 Z",
    id: "Icon_User_Gray-16px"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserGray16Px);
export default __webpack_public_path__ + "static/media/Icon_User_Gray-16px.ede08dcbe51f3eb601bae690dafd728d.svg";
export { ForwardRef as ReactComponent };